// Textos de Marketing › Notificaciones push (envío manual a usuarios concretos).
// Se registran junto al resto de vocabularios en AppComponent; setTranslation
// los fusiona.
export const locale = {
  lang: 'en',
  data: {
    PUSH_NOTIFICATIONS: {
      NOTE_TITLE: 'Hand-written push notification to specific users',
      NOTE_TEXT:
        'It is sent as an operational notification, without choosing the category, with one request per user. “Accepted by the server” does not mean “delivered”: if the user has no devices or has turned these notifications off, it does not reach them.',
      RECIPIENTS_TITLE: 'Recipients',
      RECIPIENTS_SUB:
        'Up to {{max}} users per send. Search for them by name, email or phone.',
      RECIPIENTS_COUNT: 'Selected: {{count}} of {{max}}',
      RECIPIENTS_EMPTY: 'You have not chosen any user yet.',
      RECIPIENTS_MAX:
        'You already have the maximum of {{max}} recipients. Remove one to add another.',
      RECIPIENTS_LIST_ARIA: 'Selected recipients',
      REMOVE: 'Remove',
      REMOVE_ARIA: 'Remove {{name}}',
      MESSAGE_TITLE: 'Message',
      MESSAGE_SUB: 'What the user will see in the notification.',
      FIELD_TITLE: 'Title',
      FIELD_TITLE_PLACEHOLDER: 'E.g.: Changes to your trip tomorrow',
      FIELD_BODY: 'Text',
      FIELD_BODY_PLACEHOLDER: 'Write the notification message',
      SEND: 'Send',
      SENDING: 'Sending {{done}} of {{total}}…',
      SEND_DISABLED_RECIPIENTS: 'Choose at least one recipient to send',
      SEND_DISABLED_TITLE: 'Write the title to send',
      SEND_DISABLED_BODY: 'Write the text to send',
      CONFIRM_TITLE: 'Send push (recipients: {{count}})',
      CONFIRM_TEXT:
        'It is sent to each user separately. Do not close the page until it finishes.',
      CONFIRM_OK: 'Send',
      CONFIRM_CANCEL: 'Cancel',
      RESULT_OK: 'Accepted by the server: {{ok}} of {{total}}',
      RESULT_FAILED: 'Could not be sent: {{count}}',
      RESULT_FAILED_HINT:
        'They stay as recipients, with the same message, so you can retry.',
      ERROR_UNKNOWN: 'The server did not give a reason.',
    },
  },
};
